module.exports = __webpack_public_path__ + "static/empty-mourning-thumb-0fd7f4189395b71bb76186643f485335.png";